export default {
  vessel: {},
  isFetchingPictures: false,
  pictures: [],
  lightBoxPictures: []
};
